import styled from 'styled-components/macro'

export const LoadRateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: fit-content;
`
